export const CONTENT_EDITABLE_CLASSNAME =
  "easy_email_pro_preview_content_editable";

export const SLATE_NODE_PLACEHOLDER_CLASSNAME =
  "easy_email_pro_slate_node_placeholder";

export const SLATE_CODE_BLOCK_CLASSNAME =
  "easy_email_pro_slate_code_block";
